import { LatLngExpression } from 'leaflet';
import { createContext, h } from 'preact';
import { StateUpdater, useContext, useState } from 'preact/hooks';
import { HasWifi } from '../icons/Wifi';

export type Cafe = {
    address?: {
        directions?: string;
        fullDisplayName?: string;
        neighbourhood?: string;
        zipCode?: string;
    };
    hasWifi: HasWifi;
    hours?: string;
    id: number;
    name: string;
    position: LatLngExpression;
    url?: string;
}
export type PointsOfInterest = {
    /**
     * Ordered list of café locations.
     */
    cafes: Cafe[];
    highlightedCafe: null | number;
    /**
     * Area in which the user wishes to search.
     */
    user: {
        center: LatLngExpression;
        radius: number;
    };
};

const DEFAULT_POINTS_OF_INTEREST: PointsOfInterest = {
    cafes: [],
    highlightedCafe: null,
    user: {
        center: null,
        radius: 500,
    },
};

const PoiCtx = createContext<PointsOfInterest>(DEFAULT_POINTS_OF_INTEREST);
const PoiUpdaterCtx = createContext<StateUpdater<PointsOfInterest>>(() => void 0);

export default function PointsOfInterestProvider({ children }) {
    const [pois, setPois] = useState(DEFAULT_POINTS_OF_INTEREST);

    return (
        <PoiCtx.Provider value={pois}>
            <PoiUpdaterCtx.Provider value={setPois}>
                {children}
            </PoiUpdaterCtx.Provider>
        </PoiCtx.Provider>
    );
}

export function usePointsOfInterest() {
    return useContext(PoiCtx);
}

export function usePointsOfInterestUpdater() {
    return useContext(PoiUpdaterCtx);
}
